import { getRootUrl } from '@bingads-webui-react/copilot-utils';
import { getBotMtApiUrl } from './utils/xandr-bot-mt';
import type { ConversationRequestContext, RequestHeaders } from './types';

export interface IRenameConversationProps extends ConversationRequestContext {
  newTitle: string;
}

function renameConversationUrl({
  cid,
  uid,
  conversationId,
  newTitle,
  productName,
}: IRenameConversationProps) {
  if (productName === 'xandr_curate' || productName === 'xandr_monetization') {
    // need to bypass /tokenexchange for xandr products, default to token exchange for all others
    return `${getBotMtApiUrl()}/chathistory/rename?userId=${encodeURIComponent(uid)}&customerId=${encodeURIComponent(cid)}&conversationId=${encodeURIComponent(conversationId)}&newTitle=${encodeURIComponent(newTitle)}`;
  }
  return `${getRootUrl()}/tokenexchange/chatrename?uid=${encodeURIComponent(uid)}&cid=${encodeURIComponent(cid)}&conversationId=${encodeURIComponent(conversationId)}&newTitle=${encodeURIComponent(newTitle)}`;
}

export function renameConversation({
  cid,
  uid,
  newTitle,
  conversationId,
  productName,
  authToken,
}: IRenameConversationProps) {
  const url = renameConversationUrl({
    cid,
    uid,
    conversationId,
    newTitle,
    productName,
  });
  const isXandrProduct = productName === 'xandr_curate' || productName === 'xandr_monetization';
  const headers: RequestHeaders = {
    'Content-Type': 'application/json',
    'x-requested-with': 'XMLHttpRequest',
  };
  if (isXandrProduct && authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }

  return window.fetch(url, {
    method: 'POST',
    headers,
    credentials: isXandrProduct ? 'omit' : 'include',
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(await response.text());
      }
      return {
        data: { success: true },
        hasError: false,
      };
    })
    .catch(error => ({
      hasError: true,
      message: 'Failed to rename conversation',
      error: error?.message,
    }));
}
